import {
  ENDPOINTS,
  IChallengeEvaluateOutput,
  IChallengeTranscribeOutput,
  ISendAudioPractice,
  ISendAudioChallengeOuput,
  Requests,
  getApiUrl,
  IQuotaOutput,
  IMyPracticesOutput,
  IWordMatchInput,
  IWordMatchOutput,
  IGrammarVocabularyInput,
  ExerciseData,
} from "@/common";

export const sendAudioPractice = async (payload: ISendAudioPractice): Promise<ISendAudioChallengeOuput> => {
  const apiUrl = getApiUrl(ENDPOINTS.POST_PRACTICES_UPLOAD);
  const data: any = await Requests.post(apiUrl, payload, true, false);
  return data;
};

export const postPracticeTranscribe = async (id: string): Promise<IChallengeTranscribeOutput> => {
  const apiUrl = getApiUrl(ENDPOINTS.POST_PRACTICES_TRANSCRIBE, { id }, true);
  const { data }: any = await Requests.post(apiUrl);
  return data;
};

export const postPracticeEvaluate = async (id: string): Promise<IChallengeEvaluateOutput> => {
  const apiUrl = getApiUrl(ENDPOINTS.POST_PRACTICES_EVALUATE, { id }, true);
  const { data }: any = await Requests.post(apiUrl);
  return data;
};

export const getQuotaPractice = async (): Promise<IQuotaOutput> => {
  const apiUrl = getApiUrl(ENDPOINTS.GET_QUOTA_PRACTICE);
  const { data }: any = await Requests.get(apiUrl);

  return data;
};

export const getMyPractices = async (): Promise<IMyPracticesOutput[]> => {
  const apiUrl = getApiUrl(ENDPOINTS.GET_MY_PRACTICE);
  const data: any = await Requests.get(apiUrl);
  const dataParse = data?.map((item: any) => {
    if (item?.result) {
      return { ...item, result: JSON.parse(item.result) };
    }
    return item;
  });
  return dataParse;
};

export const postWordMatchEvaluate = async ({ id, original_answer }: IWordMatchInput): Promise<IWordMatchOutput> => {
  const apiUrl = getApiUrl(ENDPOINTS.POST_WORD_MATCH_EVALUATE, { id }, true);
  const { data }: any = await Requests.post(apiUrl, {
    original_answer,
  });
  return data;
};

export const grammarVocabularyPractice = async (payload: IGrammarVocabularyInput): Promise<ExerciseData> => {
  const apiUrl = getApiUrl(ENDPOINTS.GRAMMAR_VOCABULARY_PRACTICE);
  const { data } = await Requests.post(apiUrl, payload);
  return data;
};

export interface ICheckQuestionInput {
  question: string;
}

export interface ICheckQuestionOutput {
  isCorrect: boolean;
  originalQuestion: string;
  correctedQuestion: string;
  explanation: string;
  suggestions: string[];
}

export const postCheckQuestion = async (payload: ICheckQuestionInput): Promise<ICheckQuestionOutput> => {
  const apiUrl = getApiUrl(ENDPOINTS.POST_PRACTICES_CHECK_QUESTION);
  const { data }: any = await Requests.post(apiUrl, payload);
  return data;
};


export interface IPronunciationAnalyzeInput {
  sentence: string;
  audioFile: File;
}

export interface IPronunciationPhonemeResult {
  phone: string;
  qualityScore: number;
  soundMostLike?: string;
  extent?: [number, number];
  stressLevel?: number;
  predictedStress?: number;
}

export interface IPronunciationSyllableResult {
  letters: string;
  stress_level: number; // 0=unstressed, 1=primary, 2=secondary
  predicted_stress_level: number;
  stress_score: number; // 0–1000
  intonation: [string | null, string | null]; // [from_prev, in_current]
  pitch_range: [number, number]; // [begin_hz, end_hz]
  extent?: [number, number];
  phone_count?: number;
}

export interface IWordIntonationResult {
  word: string;
  syllable_intonation_list: [string | null, string | null][]; // per syllable
}

export interface IPronunciationAnalyzeOutput {
  words: Array<{
    word: string;
    isCorrect: boolean;
    ipa?: string;
    userIpa?: string;
    score?: number;
    phonemes?: IPronunciationPhonemeResult[];
    syllables?: IPronunciationSyllableResult[];
    extent?: [number, number];
  }>;
  overallScore?: number;
  accuracyScore?: number;
  completenessScore?: number;
  fluencyScore?: number;
  wordIntonationList?: IWordIntonationResult[];
}

export const pronunciationAnalyze = async (
  payload: IPronunciationAnalyzeInput
): Promise<IPronunciationAnalyzeOutput> => {
  console.log("payload", payload);
  const apiUrl = getApiUrl(ENDPOINTS.PRACTICE_PRONUNCIATION_ANALYZE);
  // const formData = new FormData();
  // formData.append("sentence", payload.sentence);
  // formData.append("audioFile", payload.audioFile);
  const { data }: any = await Requests.post(apiUrl, payload, true, false);
  return data;
};
